import React, { useState, useEffect, useRef } from 'react';
import ConsentModal from './ConsentModal';
import AudioRecorder from './AudioRecorder';
import TranscriptBox from './TranscriptBox';

const API_URL = process.env.REACT_APP_TRANSCRIBE_API_URL;
const MAX_DURATION = 12;

const VoiceLoop = () => {
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const [showUploadWarning, setShowUploadWarning] = useState(false);
  const [timer, setTimer] = useState(MAX_DURATION);
  const [isRecording, setIsRecording] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);
  const [consentDismissed, setConsentDismissed] = useState(false);
  const mimeTypeRef = useRef('');

  // Show warning when upload is clicked, but do not allow upload
  const handleUploadClick = () => {
    setShowUploadWarning(true);
    setTimeout(() => setShowUploadWarning(false), 4000);
  };

  // Timer logic for countdown
  useEffect(() => {
    let interval = null;
    if (isRecording && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (!isRecording) {
      setTimer(MAX_DURATION);
    }
    if (timer === 0 && isRecording) {
      setIsRecording(false);
    }
    return () => clearInterval(interval);
  }, [isRecording, timer]);

  const handleRecordingStart = () => {
    setIsRecording(true);
    setTimer(MAX_DURATION);
  };

  const handleRecordingStop = () => {
    setIsRecording(false);
  };

  // Handle audio recording complete (limit to 1 minute in AudioRecorder)
  const handleRecordingComplete = async (audioBlob, mimeType) => {
    setIsRecording(false);
    setTimer(MAX_DURATION);
    setLoading(true);
    setResponse('');
    const reader = new FileReader();
    reader.onloadend = async () => {
      const base64 = reader.result.split(',')[1];
      console.log('API URL:', process.env.REACT_APP_TRANSCRIBE_API_URL);
      console.log("heeloo")
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ audio: base64, mimeType }),
        });
        console.log(mimeType);
        if (!res.ok) {
          console.error(`API Error: ${res.status} ${res.statusText}`);
          setResponse(
            "Sorry, we couldn't process your audio right now. Please try again later or check your connection."
          );
          return;
        }
        const result = await res.json();
        setResponse(result.text || JSON.stringify(result));
      } catch (err) {
        console.error('Network or server error:', err);
        setResponse(
          "Sorry, something went wrong connecting to our server. Please check your internet connection or try again later."
        );
      } finally {
        setLoading(false);
      }
    };
    reader.readAsDataURL(audioBlob);
  };

  return (
    <div className="container mt-4">
      <ConsentModal
        show={!consentGiven && !consentDismissed}
        onAgree={() => setConsentGiven(true)}
        onDisagree={() => setConsentDismissed(true)}
      />
      <div
        className="shadow-lg p-4 mb-4"
        style={{
          borderRadius: '1.5rem',
          background: 'linear-gradient(135deg, #e0e7ff 0%, #f0fdfa 100%)',
          border: 'none',
        }}
      >
        <h2 className="text-center mb-3" style={{ color: '#3b82f6', fontWeight: 'bold' }}>
          <span role="img" aria-label="microphone" style={{ fontSize: '2rem', marginRight: '0.5rem' }}>🎤</span>
          VoiceLoop AI Agent
        </h2>
        <p className="text-center" style={{ fontSize: '1.1rem', color: '#374151', marginBottom: '2rem' }}>
          <strong>VoiceLoop</strong> turns your spoken ideas into organized, polished text.<br />
        </p>
        {/* Audio Upload */}
        <div className="mb-4">
          <label className="form-label" style={{ fontWeight: 'bold', color: '#6366f1' }}>
            Upload an audio file:
          </label>
          <input
            type="file"
            className="form-control"
            accept="audio/*"
            onClick={e => {
              e.preventDefault();
              e.target.value = null; // Prevent file dialog from opening
              handleUploadClick();
            }}
            style={{ cursor: 'not-allowed', background: '#f3f4f6' }}
          />
          {showUploadWarning && (
            <div style={{ color: '#ef4444', fontWeight: 500, marginTop: '0.5rem' }}>
              File upload is <strong>in development</strong> and not available yet.<br />
              Please use the recording feature (up to {MAX_DURATION} second{MAX_DURATION > 1 ? 's' : ''}).
            </div>
          )}
        </div>
        {/* Audio Recording */}
        <div className="mb-4 text-center">
          <div style={{ marginBottom: '0.5rem', fontWeight: 'bold', color: isRecording ? '#16a34a' : '#64748b' }}>
            {isRecording ? `Recording... ${timer}s left` : 'Ready to record'}
          </div>
          <AudioRecorder
            onRecordingComplete={handleRecordingComplete}
            maxDuration={MAX_DURATION}
            onStart={handleRecordingStart}
            onStop={handleRecordingStop}
            disabled={!consentGiven}
          />
        </div>
        {/* Response Display */}
        {loading && (
          <div className="alert alert-info mt-3 shadow">
            <strong>Processing your audio...</strong>
          </div>
        )}
        {response && !loading && (
          <TranscriptBox transcript={response} />
        )}
      </div>
    </div>
  );
};

export default VoiceLoop;
